const access = {
  ADMIN: "Admin",
  MARKET_EXPERT: "Market Expert",
  STOCKANTS_ADMIN: "StockAnts Admin",
  BROKER_ADMIN: "Broker Admin",
};

exports.access = access;
